import { ready } from "./utils";
import { sweepstakesFormValidation, sweepstakesFormThankYouModal } from "./sweepstakes-form";

ready(() => {
    sweepstakesFormValidation();
    sweepstakesFormThankYouModal();
});